<template>
  <div class="page-container">
    <el-card>
      <div slot="header">
        <span>通知管理</span>
        <el-button style="float: right;" size="small" type="primary" @click="showCreate = true">发布通知</el-button>
      </div>
      <el-table :data="list" v-loading="loading" style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="content" label="内容" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createdAt" label="发布时间" width="180"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteNotice(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="发布通知" :visible.sync="showCreate" width="50%">
      <el-form :model="form">
        <el-form-item label="标题">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input type="textarea" v-model="form.content" :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="showCreate = false">取消</el-button>
        <el-button type="primary" @click="create">发布</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { vpost } from "@/util/post";

export default {
  name: "NoticeManage",
  data() {
    return { list: [], loading: false, showCreate: false, form: { title: "", content: "" } };
  },
  mounted() { this.fetchData(); },
  methods: {
    fetchData() {
      this.loading = true;
      vpost("/notice/list").then(res => {
        if (res.code === 200) this.list = res.data || [];
      }).finally(() => this.loading = false);
    },
    create() {
      if (!this.form.title || !this.form.content) return this.$message.error("标题和内容不能为空");
      vpost("/notice/create", this.form).then(res => {
        if (res.code === 200) {
          this.$message.success("发布成功");
          this.showCreate = false;
          this.fetchData();
        }
      });
    },
    deleteNotice(id) {
      vpost("/notice/delete?id=" + id).then(res => {
        if (res.code === 200) {
          this.$message.success("删除成功");
          this.fetchData();
        }
      });
    }
  }
};
</script>
